<template>
  <div class="pagemain">
    <div style="height: 10px"></div>
    <div class="download_div">
      <div class="title_div">
        <div class="title_icon"></div>
        APP下载
      </div>
      <div>
        <div class="download_icon_box">
          <div
            class="login_box_inner login_box_inner_hover"
            @click="click_download_app('android')"
          >
            <div>
              <span class="iconfont iconanzhuo loginicon"></span>
            </div>
            <span class="login_text">安卓APP下载</span>
          </div>
          <div
            class="login_box_inner login_box_inner_hover"
            @click="click_download_app('ios')"
          >
            <div>
              <span class="iconfont iconpingguo loginicon"></span>
            </div>
            <span class="login_text">苹果APP下载</span>
          </div>

          <!-- <div
            class="login_box_inner login_box_inner_hover"
            @click="click_download_app('win')"
          >
            <div>
              <span class="iconfont iconwin loginicon"></span>
            </div>
            <span class="login_text">Win客户端下载</span>
          </div>
          <div
            class="login_box_inner login_box_inner_hover"
            @click="click_download_app('mac')"
          >
            <div>
              <span class="iconfont iconmac loginicon"></span>
            </div>
            <span class="login_text">Mac客户端下载</span>
          </div> -->
        </div>
      </div>
      <div style="height: 10px"></div>
      <div class="title_div">
        <div class="title_icon"></div>
        相关公众号
      </div>
      <div>
        <div class="download_icon_box">
          <div
            class="login_box_inner login_box_inner_hover"
            @click="click_download_mp('dxxt')"
          >
            <div>
              <span class="iconfont icongongzhonghao loginicon"></span>
            </div>
            <span class="login_text">大象系统</span>
          </div>

          <div
            class="login_box_inner login_box_inner_hover"
            @click="click_download_mp('dxygfwzx')"
          >
            <div>
              <span class="iconfont icongongzhonghao loginicon"></span>
            </div>
            <span class="login_text">员工服务中心</span>
          </div>
          <div
            class="login_box_inner login_box_inner_hover"
            @click="click_download_mp('dxhbfw')"
          >
            <div>
              <span class="iconfont icongongzhonghao loginicon"></span>
            </div>
            <span class="login_text">伙伴服务中心</span>
          </div>
        </div>
      </div>
      <div style="height: 10px"></div>
      <div class="title_div">
        <div class="title_icon"></div>
        浏览器插件
      </div>
      <div>
        <div class="download_icon_box">
          <div
            class="login_box_inner login_box_inner_hover"
            @click="click_install_crx('resume_crx')"
          >
            <div>
              <span class="iconfont iconchajian loginicon chajian_icon"></span>
            </div>
            <span class="login_text">大象简历库插件</span>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="qrcode_show"
      :title="qrcode_show_title"
      :footer-hide="true"
      width="320"
    >
      <div class="qrcode_div">
        <div class="qrcode" ref="qrCodeUrl"></div>
      </div>
      <div class="qrcode_tishi">
        <span v-if="download_status == 'ios'"
          >使用苹果相机扫一扫，用Safari浏览器打开，需要搭配苹果官方测试APP【TestFlight】一同使用，不可卸载</span
        >
        <span v-if="download_status == 'android'"
          >使用安卓手机扫一扫，下载APK安装包进行安装</span
        >
      </div>
      <!-- <div style="margin-top: 10px">
        1、苹果手机请用默认浏览器打开，按流程安装，注意安装成功后不可以卸载【TestFlight】，否则后续无法自动更新
        <br />
        2、安卓手机请允许外部应用安装
      </div> -->
    </Modal>

    <Modal
      width="350"
      v-model="wxmp_qrcode_show"
      :mask-closable="true"
      title="微信公众号二维码"
      :closable="true"
      :footer-hide="true"
    >
      <div>
        <img
          v-if="wxmp_qrcode_status == 'dxxt'"
          class="wxmp_qr_img"
          src="@/assets/image/wxmp/daxiang_wxmp.png"
          alt=""
        />
        <img
          v-if="wxmp_qrcode_status == 'dxygfwzx'"
          class="wxmp_qr_img"
          src="@/assets/image/wxmp/daxiang_wxygfwzx.png"
          alt=""
        />
        <img
          v-if="wxmp_qrcode_status == 'dxhbfw'"
          class="wxmp_qr_img"
          src="@/assets/image/wxmp/daxiang_huobanfuwu.png"
          alt=""
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http";
import QRCode from "qrcodejs2";
import { Base64 } from "js-base64";
export default {
  name: "app_download",
  data() {
    return {
      wxmp_qrcode_show: false,
      qrcode_show: false,
      qrcode_show_title: "",
      wxmp_qrcode_status: false,
      download_status: "",
    };
  },
  methods: {
    open() {
      console.log("打开相关下载");
    },

    click_install_crx(status) {
      if (status == "resume_crx") {
        var url = "https://alidocs.dingtalk.com/i/p/7xZBGL2jAMMXL1wvrqGd907arE2MnzaV";
        open_new_page(url);
      }
    },

    click_download_mp(status) {
      this.wxmp_qrcode_show = true;
      this.wxmp_qrcode_status = status;
    },

    click_download_app(status) {

      this.$Message.info('请在手机应用商店搜索【大象系统】进行安装即可')
      return;

      this.download_status = status;
      var that = this;
      var obj = {
        download_status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/download",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            if (that.download_status == "android") {
              that.qrcode_show_title = "大象APP[安卓端]扫码下载";
              // var urlb64 = Base64.encode(res.data.download_url);
              // var download_str = encodeURIComponent(urlb64);
              // var url =
              //   "https://www.daxiangsys.com/app/download?version_id=" +
              //   res.data.download_url;
              // console.log(url);
              var url = res.data.download_url;
              this.$refs.qrCodeUrl.innerHTML = "";
              var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: url, // 需要转换为二维码的内容
                width: 150,
                height: 150,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              that.qrcode_show = true;
            }

            if (that.download_status == "ios") {
              that.qrcode_show_title = "大象APP[苹果端]扫码下载";
              var url = res.data.download_url;

              this.$refs.qrCodeUrl.innerHTML = "";
              var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: url, // 需要转换为二维码的内容
                width: 150,
                height: 150,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              that.qrcode_show = true;
            }

            if (that.download_status == "win") {
              that.qrcode_show_title = "Win7、Win10、Win11下载";
              var url = res.data.download_url;

              this.$Modal.confirm({
                title: "提示",
                content: "<p>是否下载[大象Win]安装包？下载后双击完装即可。</p>",
                onOk: () => {
                  open_new_page(url);
                },
                onCancel: () => {},
              });
            }
            if (that.download_status == "mac") {
              that.qrcode_show_title = "苹果MAC系统下载";
              var url = res.data.download_url;

              this.$Modal.confirm({
                title: "提示",
                content: "<p>是否下载[大象MAC]安装包？下载后双击完装即可。</p>",
                onOk: () => {
                  open_new_page(url);
                },
                onCancel: () => {},
              });
            }
          } else {
            that.$Message.info(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.title_div {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-top: 5px;
  font-weight: 600;
  font-size: 15px;
  padding-bottom: 10px;
  margin-bottom: 0px;
  border-bottom: 1px solid #f5f5f5;
}

.title_icon {
  border-radius: 3px;
  margin-right: 10px;
  height: 15px;
  width: 8px;
  background: #0466dd;
}
.pagemain {
  width: calc(100vw - 120px);
  background: #ececec;
  min-height: 100vh;
}
.cutmp3 {
  cursor: pointer;
}

.qrcode_tishi {
  font-size: 13px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.qrcode_div {
  display: flex;
  justify-content: center;
}

.wxmp_qr_img {
  width: 100%;
  border-radius: 10px;
}

.loginicon {
  font-size: 24px;
}

.iconanzhuo {
  color: #2b9c25;
}

.iconmac {
  color: #000;
}

.iconpingguo {
  color: #000;
}

.iconwin {
  color: #5ca5ff;
}
.login_text {
  color: #8e8e8e;
  font-size: 13px;
}

.icongongzhonghao {
  color: #0dcc60;
}

.login_box_inner {
  width: 120px;
  flex-shrink: 0;

  text-align: center;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 1px #9f9f9f;
  margin: 10px;
  cursor: pointer;
}

.login_box_inner:hover {
  box-shadow: 0 0 2px #0466dd;
}

.download_icon_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.chajian_icon {
  color: #0466dd;
}

.download_div {
  margin: 10px;
  background: #fff;
  border-radius: 8px;
  padding: 10px;
}
</style>
